<!--
 * @Author: Merlin
 * @Date: 2024-04-04 13:18:51
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-06 13:36:27
 * @Description: 
-->
<template>
    <div>
        <RouletteGame
            type="result" 
            :historyData="historyData"
            :key="'show-as-result'"
        />
        <!-- ↑游戏画面 -->
        <!-- ↓列表 -->
        <section
            class="bg-grey-100 rounded-2xl p-3 transition-all duration-500 overflow-hidden"
            :style="{ 'max-height': `${iMaxHeight}px` }"
        >
            <div class="flex items-center justify-between cursor-pointer"
                @click="onCollapse"
            >
                <div class="flex items-center gap-1">
                    <IconSvgUse class="w-6 h-6" use="icon-campaign" />
                    <span class="text-white">
                        {{ $t('roulette.betsList') }}
                    </span>
                </div>
                <QIcon class="text-white"
                    :name="collapsed ? 'arrow_drop_up' : 'arrow_drop_down'" 
                />
            </div>
            <!-- ↑ 标题 -->
            <!-- ↓ 主列表 -->
            <ul class="main-list" >
                <li class="board-roullete-list-item"
                    v-for="(cur, idx) of listData" :key="idx" 
                >
                    <p class="board-roullete-list-item-title">
                        <!-- Split 4/7 -->
                        {{cur.title }}
                    </p>
                    <div class="board-roullete-list-item-body">
                        <div class="board-roullete-list-item-body-block">
                            <h4>{{ $t('Bet') }}</h4>
                            <span class="currency bet-details__info-bet">
                                <CurrentCoin
                                    class="currency__icon"
                                    size="18px" 
                                    :name="history.currency"
                                ></CurrentCoin>
                                <span style="font-size: 14px" >
                                    <CasinoWidgetColoredAmount
                                        class="font-digits"
                                        :colors="['', '#55657e']"
                                        :amount="cur.betAmount" 
                                    ></CasinoWidgetColoredAmount>
                                </span>
                            </span>
                        </div>
                        <div class="board-roullete-list-item-body-block">
                            <h4>{{ $t('commonInfo.coefficient') }}</h4>
                            <p class="board-roullete-list-green">
                                x {{cur.coef.toFixed(2)}}
                            </p>
                        </div>
                        <div class="board-roullete-list-item-body-block">
                            <h4>{{$t('roulette.payout')}}</h4>
                            <span class="currency bet-details__info-bet">
                                <CurrentCoin
                                    class="currency__icon"
                                    size="18px" 
                                    :name="history.currency"
                                ></CurrentCoin>
                                <span style="font-size: 14px">
                                    <CasinoWidgetColoredAmount
                                        class="font-digits"
                                        :colors="['', '#55657e']"
                                        :amount="cur.payout" 
                                    ></CasinoWidgetColoredAmount>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="btn-grd-line"></div>
                </li>
            </ul>
        </section>
    </div>
</template>


<script lang="ts" >
export default defineComponent({name: 'RouletteContent'});
</script>

<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import RouletteGame from '@/pages/casino/rouletteGame/index.vue';
import {kk, oBetPattern} from '@/pages/casino/rouletteGame/js/rouletteData'; 
import {fnGetRouletteConfig, fnGetMulti} from '~/pages/casino/rouletteGame/js/rouletteFn';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
    fnScrollMove: { 
        type: Function,
    },
});

const oGameConfig = fnGetRouletteConfig(); // 返回取得一个 promise 
const {t: $tFn} = useNuxtApp().$i18n;
const historyData = computed(()=>{
    const oHistory = deepCopy(props.history);
    oHistory.prediction.map(cur => {
        const {cells} = cur;
        // ↓ 这个 cur.strVal 用于传递给子组件 
        cur.strVal = (()=>{
            if (cells.length > 1){
                const arr = [...cells].sort((aa, bb) => {
                    return aa - bb;
                });
                return arr.join(',');
            }
            return String(cells[0]);
        })();

        return cur;
    });
    return oHistory;
});


const listData = ref([]);
const collapsed = ref(false); // 控制伸缩 
const iMaxHeight = computed(()=>{ // 控制伸缩后的高度
    if (collapsed.value){
        const len = historyData.value.prediction.length;
        // ↓ 行高 + margin-top + 人工追加值
        let iHeight = (182 + 16 + 5) * len + 60;
        return iHeight;
    }
    return 48;
});

const onCollapse = () => {
    const isShow = !collapsed.value;
    collapsed.value = isShow;
    if (isShow) {
        const finalValue = Math.min(500, iMaxHeight.value);
        props.fnScrollMove(finalValue); 
    }
};

// ↓检查是否相同 
const checkIfSame = (aa, bb) => {
    const cc = new Set([
        ...aa,
        ...bb,
    ]);
    return aa.length === bb.length && cc.size === aa.length;
};


// 说明：常量 C_map, tt 格式如下：
// 中奖区名称：[中奖区方块数量, 中奖区的显示名]; 
// 其中的“中奖区的显示名” 已经被停用，使用 i18n 显示多语言标题 
const C_map = { 
    "1-12": [12, "Dozen 1st-12"],
    "13-24": [12, "Dozen 2nd-12"],
    "25-36": [12, "Dozen 3rd-12"],
    "1to18": [18, "1-18"],
    "19to36": [18, "19-36"],
    even: [18, "EVEN"],
    odd: [18, "ODD"],
    red: [18, "Red"],
    black: [18, "Black"]
};

const aColumn3 = ["2-1-1", "2-1-2", "2-1-3"];
const tt = {
    "2-1-3": [12, "3rd column 2 to 1", 0],
    "2-1-2": [12, "2nd column 2 to 1", 1],
    "2-1-1": [12, "1st column 2 to 1", 2]
};

watch(historyData, async (oNewHistory)=>{
    const oConfig = await oGameConfig;
    const {coefficients} = oConfig?.['config'] || {};
    // console.log('roulette 游戏配置', deepCopy(coefficients)); 
    // console.log('roulette 游戏历史', deepCopy(oNewHistory)); 
    // ↓开奖结果数字
    const y = Number(oNewHistory?.randomSeed?.split?.("_")?.[0]);
    // ↓开始计算 
    listData.value = oNewHistory.prediction.map((oPrams)=>{
        const { cells, amount } = oPrams;
        for (const [idx, val] of cells.entries()){
            if (typeof val == 'string' && /^\d+$/.test(val)){
                cells[idx] = Number(val);
            }
        }
        if (cells.length > 1){
            cells.sort((aa, bb) => aa - bb);
        }
        const firstOne = cells[0];
        let b_length = cells.length;
        let i_win = false;
        let f_title = "";
        // ↓ 三大行 
        if (aColumn3.includes(firstOne)) {
            b_length = tt[firstOne][0];
            f_title = $tFn(`roulette.title_${firstOne}`); // tt[firstOne][1];
            const idx = tt[firstOne][2]; // ←取得索引值 
            i_win = kk["2-1"][idx].includes(y); 
        } else {
            const sCellsTail = ' ' + cells.join("/");
            if (typeof firstOne == "string"){
                b_length = C_map[firstOne][0];
                f_title = $tFn(`roulette.title_${firstOne}`); // C_map[firstOne][1];
                i_win = kk[firstOne].includes(y);
            } else if (cells.length === 1){
                i_win = (y === firstOne);
                f_title = $tFn('roulette.bet_Straight') + ` ${firstOne}`; // `Straight ${firstOne}`;
            } else if (cells.length === 2){
                oBetPattern['2'].forEach(t=>{
                    checkIfSame(t, cells) && (
                        f_title = $tFn('roulette.bet_Split') + sCellsTail,
                        i_win = cells.includes(y)
                    );
                });
            } else if (cells.length === 3){
                oBetPattern['3'].forEach(t=>{
                    checkIfSame(t, cells) && (
                        f_title = $tFn('roulette.bet_Street') + sCellsTail,
                        i_win = cells.includes(y)
                    );
                });
            } else if (cells.length === 4){
                oBetPattern['4'].forEach(t=>{
                    checkIfSame(t, cells) && (
                        f_title = $tFn('roulette.bet_Corner') + sCellsTail,
                        i_win = cells.includes(y)
                    );
                });
            } else {
                oBetPattern['6'].forEach(t=>{
                    checkIfSame(t, cells) && (
                        f_title = $tFn('roulette.bet_SixLine') + sCellsTail,
                        i_win = cells.includes(y)
                    );
                });
            }
        }
        // ↓ 顶替旧版计算倍数的方法 36 / b_length 
        let multiple = i_win ? fnGetMulti(coefficients, cells) : 0;
        if (i_win && !multiple){
            console.error('倍数查询异常', deepCopy(cells));
        }
        const payout = amount * multiple;
        return {
            coef: multiple,
            betAmount: amount,
            payout, 
            title: f_title,
            cells,
        };
    });
    const testSum = listData.value.reduce((result, cur)=>{
        return result + cur.payout;
    }, 0);
    if (oNewHistory.winAmount != testSum){
        console.error('winAmount 值不一致，线上与本地值：', oNewHistory.winAmount, testSum);
    }else if (listData.value.some(cur => !cur.title)){
        console.error('标题缺失'); 
    }
    if (1 && import.meta.dev){
        const obj = deepCopy(oNewHistory);
        obj.prediction.forEach(cur => {
            cur.cells = `[${cur.cells.join(', ')}]`;
        });
        const arr = listData.value.map(cur=>{
            const obj = deepCopy(cur);
            obj.coef ||= '';
            obj.payout ||= '';
            obj.cells &&= obj.cells.join(',');
            return obj;
        });
        
        console.log("投注信息：\n", obj);
        console.log("派奖详情：\n", arr);
    }
}, {
    deep: true,
    immediate: true,
});

</script>


<style scoped lang="scss">
.main-list{
    margin: 10px 0 0;
    height: max-content;
}
.currency__icon{
    display:  inline-block;
    margin-right: 3px;
}

.board-roullete-list-item-body-block{
    h4{
        line-height: 24px;
        margin: 0;
    }
}

.bet-details__info-bet{
    font-weight: bold;
    display: flex;
    align-items: center;
}

// -------------------------------------

.board-roullete {
    margin-bottom: -24px;
    width: 100%
}

.board-roullete-stage {
    /* background-image: url(./greenBG.BgXDGmOP.png); */
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 433px;
    position: relative;
    width: 100%
}

.board-roullete-list {
    background: #1c2532;
    border-radius: 14px;
    height: -moz-max-content;
    height: max-content;
    overflow: hidden;
    padding: 12px;
    transition: all 1s;
    width: 100%
}

.board-roullete-list-green {
    color: var(--accents-green-default,#1bb83d);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -.28px;
    line-height: 125%;
    margin: 0
}

.board-roullete-list-header {
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: space-between;
    margin: 0 0 18px;
    width: 100%
}

.board-roullete-list-header h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin: 0
}

.board-roullete-list-item {
    margin-top: 16px;
    width: 100%
}

.board-roullete-list-item-title {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    margin: 0 0 12px;
    text-align: center
}

.board-roullete-list-item-body {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 60px
}

@media (max-width: 550px) {
    .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

@media (max-width: 782px) {
    .opened-left-panel .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

@media (max-width: 875px) {
    .opened-right-panel .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .board-roullete-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}

.board-roullete-list-item-body-block {
    align-items: center;
    background: #263041;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 9px 0 11px;
    width: 100%
}

.board-roullete-list-item-body-block h4 {
    color: var(--dark-shades-gray-20,#93acd3);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.24px;
    margin: 0
}

@media (max-width: 550px) {
    .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

@media (max-width: 782px) {
    .opened-left-panel .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

@media (max-width: 875px) {
    .opened-right-panel .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .board-roullete-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}

.btn-grd-line {
    background: linear-gradient(90deg,#43536d00 -3%,#43536d 48.66%,#43536d00 103.12%);
    height: 1px;
    margin: 20px 0 0;
    widows: 100%
}

.board__bets {
    align-items: center;
    aspect-ratio: 544/178;
    display: grid;
    grid-template-columns: repeat(14,1fr);
    grid-template-rows: repeat(5,1fr);
    height: 272px;
    justify-items: center;
    left: 43.5%;
    max-width: none;
    position: absolute;
    rotate: 90deg;
    top: 50%;
    transform: translate(-50%,-50%);
    transform-origin: top left;
    width: 389px;
    grid-gap: 3.1px
}

@media (max-width: 550px) {
    .board__bets {
        scale:.9
    }
}

@media (max-width: 782px) {
    .opened-left-panel .board__bets {
        scale:.9
    }
}

@media (max-width: 875px) {
    .opened-right-panel .board__bets {
        scale:.9
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .board__bets {
        scale:.9
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .board__bets {
        scale:.9
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .board__bets {
        scale:.9
    }
}

.board__bets__item {
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
    width: 100%
}

.board__bets__item--red {
    background: #861439
}

.board__bets__item--red span {
    transform: rotate(-90deg)
}

.board__bets__item--red--active {
    background: linear-gradient(0deg,#fff3,#fff3),#ed1d49;
    box-shadow: 2px 0 #b61739;
    left: -2px;
    top: 0
}

.board__bets__item--red--active .board__bet-value {
    opacity: 1
}

.board__bets__item--black {
    background: #110036
}

.board__bets__item--black span {
    transform: rotate(-90deg)
}

.board__bets__item--black--active {
    background: linear-gradient(0deg,#fff3,#fff3),#110036;
    box-shadow: 0 2px #2d2243;
    box-shadow: 2px 0 #2d2243;
    left: -2px;
    top: 0
}

.board__bets__item--black--active .board__bet-value {
    opacity: 1
}

.board__bets__item--gray {
    background: #11003680
}

.board__bets__item--gray--active {
    background: #4ebf6c99;
    box-shadow: 2px 0 #2b7047;
    left: -2px;
    top: 0
}

.board__bets__item--gray--active .board__bet-value {
    opacity: 1
}

.board__bets__mobile {
    align-items: center;
    display: grid;
    gap: 6.2px;
    grid-template-columns: repeat(14,1fr);
    grid-template-rows: repeat(1,1fr);
    height: 35px;
    justify-items: center;
    left: 0;
    position: absolute;
    // top: -43px;
    bottom: 0;
    width: 100%
}

.board__bets__mobile__item {
    align-items: center;
    background: #ffffff17;
    border: 1.309px solid hsla(0,0%,100%,.18);
    border-radius: 11.065px;
    box-shadow: 2.6px 0 #82828240;
    cursor: pointer;
    display: flex;
    font-size: 10.751px;
    height: 100%;
    justify-content: center;
    width: 100%
}

.board__bets__hiden {
    cursor: pointer;
    font-size: 5px;
    height: 100%;
    position: relative;
    white-space: nowrap;
    width: 100%
}

.board__bets__hiden-v {
    width: 20%;
    z-index: 2
}

.board__bets__hiden-h {
    height: 20%;
    z-index: 3
}

.board__bets__hiden-t {
    height: 40%;
    margin-top: -4.5rem;
    z-index: 5
}

.board__bets__hiden-v-h {
    height: 20%;
    width: 20%;
    z-index: 4
}

.board__bets__hiden-t-d {
    height: 40%;
    margin-top: -3.2rem;
    width: 20%;
    z-index: 6
}

.board__actions {
    bottom: calc(100% + 16px);
    bottom: 12%;
    gap: 4px;
    gap: 16px;
    left: 94%;
    position: absolute;
    right: 0;
    transform: rotate(-90deg) translate(36%)
}

.board__actions,.board__btn {
    align-items: center;
    display: flex;
    justify-content: center
}

.board__btn {
    aspect-ratio: 63/37;
    background: #6659d3;
    border-radius: 10px;
    box-shadow: 0 2px #3d3a7c;
    height: 28px;
    height: auto;
    padding: 0;
    position: relative;
    width: 28px;
    width: 61px
}

.board__btn:active {
    background: #5a4fbd;
    box-shadow: 0 1px #3d3a7c;
    top: 1px
}

.board__btn:active svg {
    opacity: .6
}

.board__primitive-bets {
    align-items: center;
    display: flex;
    gap: 2px
}

.board__bets-zero {
    align-items: center;
    background: #1b9636;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    height: 106px;
    justify-content: center;
    min-width: 37px;
    position: relative
}

.board__bets-zero--active {
    background: #18d34a;
    box-shadow: 0 2px #168945;
    top: -2px
}

.board__bets-zero--active .board__bet-value {
    opacity: 1
}

.board__bets-default {
    position: relative
}

.board__bets-lines {
    display: flex;
    flex-direction: column;
    gap: 2px
}

.board__bets-line {
    align-items: center;
    background: #11003680;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    position: relative;
    width: 37px
}

.board__bets-line--active {
    background: #4ebf6c99;
    box-shadow: 0 2px #2b7047;
    top: -2px
}

.board__bets-line--active .board__bet-value {
    opacity: 1
}

.board__main-bets {
    flex-wrap: wrap;
    gap: 2px
}

.board__main-bet,.board__main-bets {
    display: flex;
    justify-content: center
}

.board__main-bet {
    align-items: center;
    border-radius: 3px;
    cursor: pointer;
    height: 34px;
    position: relative;
    width: 37px
}

.board__main-bet--red {
    background: #861439
}

.board__main-bet--black {
    background: #110036
}

.board__main-bet--red.board__main-bet--active {
    background: linear-gradient(0deg,#fff3,#fff3),#ed1d49;
    box-shadow: 0 2px #b61739;
    top: -2px
}

.board__main-bet--red.board__main-bet--active .board__bet-value {
    opacity: 1
}

.board__main-bet--black.board__main-bet--active {
    background: linear-gradient(0deg,#fff3,#fff3),#110036;
    box-shadow: 0 2px #2d2243;
    top: -2px
}

.board__main-bet--black.board__main-bet--active .board__bet-value {
    opacity: 1
}

.board__bet-value {
    color: #fff;
    font-size: 11.8px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -.28px;
    line-height: 18.105px;
    margin-bottom: 0;
    opacity: .5;
    opacity: 1
}

.board__bet-value-text {
    color: #fff;
    font-size: 10.751px;
    opacity: 1
}

.board__horizontal-bets {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 2px 29px;
    left: -6px;
    pointer-events: none;
    position: absolute;
    top: 0
}

.board__horizontal-bet {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    pointer-events: all;
    position: relative;
    width: 10px
}

.board__vertical-bets {
    display: flex;
    flex-wrap: wrap;
    gap: 27px 2px;
    left: 0;
    padding-top: 31px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.board__vertical-bet {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 8px;
    justify-content: center;
    pointer-events: all;
    position: relative;
    width: 37px
}

.board__center-bets {
    display: flex;
    flex-wrap: wrap;
    gap: 21px 25px;
    left: -8px;
    padding-top: 28px;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%
}

.board__center-bet {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 14px;
    justify-content: center;
    pointer-events: all;
    position: relative;
    width: 14px
}

.board__special-bets {
    padding: 0 40px
}

.board__primitive-bets,
.board__special-top {
    margin-bottom: 2px
}

.board__special-bottom,
.board__special-top {
    display: flex;
    gap: 2px
}

.board__left-bets,
.board__middle-bets,
.board__right-bets {
    align-items: center;
    background: #11003680;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    width: 154px
}

.board__left-bets--active,
.board__middle-bets--active,
.board__right-bets--active {
    background: #4ebf6c99;
    box-shadow: 0 2px #2b7047;
    top: -2px
}

.board__left-bets--active .board__bet-value,
.board__middle-bets--active .board__bet-value,
.board__right-bets--active .board__bet-value {
    opacity: 1
}

.board__black-bets,
.board__even-bets,
.board__half-bets,
.board__odd-bets,
.board__red-bets {
    align-items: center;
    background: #11003680;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    width: 76px
}

.board__black-bets--active,
.board__even-bets--active,
.board__half-bets--active,
.board__odd-bets--active,
.board__red-bets--active {
    background: #4ebf6c99;
    box-shadow: 0 2px #2b7047;
    top: -2px
}

.board__black-bets--active .board__bet-value,
.board__even-bets--active .board__bet-value,
.board__half-bets--active .board__bet-value,
.board__odd-bets--active .board__bet-value,
.board__red-bets--active .board__bet-value {
    opacity: 1
}

.board__red-bets {
    background: #861439
}

.board__red-bets--active {
    background: linear-gradient(0deg,#fff3,#fff3),#ed1d49;
    box-shadow: 0 2px #b61739;
    top: -2px
}

.board__black-bets {
    background: #110036
}

.board__black-bets--active {
    background: linear-gradient(0deg,#fff3,#fff3),#110036;
    box-shadow: 0 2px #2d2243;
    top: -2px
}

.slot-0 {
    align-items: center;
    background: #1b9636;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    grid-column: 1;
    grid-row-end: 4;
    grid-row-start: 1;
    justify-content: center;
    position: relative
}

.slot-0 span {
    transform: rotate(-90deg)
}

.slot-0--active {
    background: #18d34a;
    box-shadow: 0 2px #168945;
    top: -2px
}

@media (max-width: 550px) {
    .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

@media (max-width: 782px) {
    .opened-left-panel .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

@media (max-width: 875px) {
    .opened-right-panel .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

@media (max-width: 890px) {
    .opened-contests-panel .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

@media (max-width: 1107px) {
    .opened-left-panel.opened-right-panel .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

@media (max-width: 1122px) {
    .opened-left-panel.opened-contests-panel .slot-0--active {
        box-shadow:2px 0 #168945;
        left: -2px;
        top: 0
    }
}

.slot-0--active .board__bet-value {
    opacity: 1
}

</style>


